import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { BussinessDocumentsResolutionModel } from 'src/app/models/management/bussiness-documents-resolution.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { BusinessDocumentTypeSelectionTable } from 'src/app/models/tables/management/bussness-document-type-selection-table.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BussinessDocumentsResolutionService } from 'src/app/services/management/bussiness-documents-resolution.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-bussiness-documents-resolution',
  templateUrl: './register-bussiness-documents-resolution.component.html',
  styleUrls: ['./register-bussiness-documents-resolution.component.scss'],
  standalone: false
})
export class RegisterBussinessDocumentsResolutionComponent implements OnInit {

  @ViewChild('bussinessDocumentsTypes') bussinessDocumentsTypesSelectionModalComponent?: CustomModalComponent | null = null;
  ascendant: boolean = true;
  businessDocumentTypeSelectionData: PagedResponseModel<BusinessDocumentTypeSelectionTable> =
    new PagedResponseModel<BusinessDocumentTypeSelectionTable>();
  bussinessDocumentsResolutionContract: BussinessDocumentsResolutionModel = new BussinessDocumentsResolutionModel();
  bussinessDocumentsResolutionId: number = 0;
  codeNameBranch: string = '';
  codeNameBussinessDocumentsType: string = '';
  codeNameEnterprise: string = '';
  columnSort: string | null = null;
  componentCitySelection = CustomTableSelectComponent;
  disabledForm: boolean = false;
  filters: ColumnResponseModel[] = [];
  formBussinessDocumentsResolution: FormGroup = new FormGroup({});
  headersBusinessDocumentType: ColumnResponseModel[] = [];
  inputsForSelectDocumentTypesModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    filters: [],
    showCheckbox: true,
    showRecover: true
  });
  isOpened: string | undefined = undefined;
  limit: number = 10;
  listTypeResolution = [
    { label: "Autoriza", value: true },
    { label: "Habilita", value: false }
  ];
  nameBussinessDocumentsTypeClass: string = '';
  nameWindow: string = 'Captura Resolución de Documentos Comerciales';
  output$ = new Subject<any>();
  page: number = 1;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  subscription: Subscription;
  url: string = 'bussiness-documents-resolution';

  constructor(private confirmDialogService: ConfirmDialogService,
    private activatedRoute: ActivatedRoute,
    private bussinessDocumentsResolutionService: BussinessDocumentsResolutionService,
    private bussinessDocumentsTypeService: BussinessDocumentsTypeService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private windowService: WindowService) {
    this.validateForm(new BussinessDocumentsResolutionModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.bussinessDocumentsResolutionId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChange(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido.', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBussinessDocumentsType(selectedItems: any) {
    const [bussinessDocumentsType] = selectedItems;
    if (bussinessDocumentsType) {
      this.resetContract(bussinessDocumentsType.bussinessDocumentsTypeId);
      await this.getBussinessDocumentsType(bussinessDocumentsType.bussinessDocumentsTypeId);
    }
  }

  async changeConsecutive(consecutive: number) {
    const bussinessDocumentsTypeId = this.formBussinessDocumentsResolution.get("bussinessDocumentsTypeId")?.value;
    if (!bussinessDocumentsTypeId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione un tipo de documento comercial.');
    }
    if (!consecutive) {
      this.resetContract(bussinessDocumentsTypeId);
      return;
    }
    try {
      const response = await firstValueFrom(this.bussinessDocumentsResolutionService.getBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId,
        consecutive));
      this.bussinessDocumentsResolutionId = response.bussinessDocumentsResolutionId;
      this.bussinessDocumentsResolutionContract = response;
      this.validateForm(this.bussinessDocumentsResolutionContract);
      this.location.replaceState(`/${this.url}/register/${this.bussinessDocumentsResolutionId}`);
    } catch (error) {
      console.error('Error al buscar la resolución de documentos comerciales.', error);
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear resoluciones de documentos comerciales.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    const bussinessDocumentsTypeId = 0;
    this.resetContract(bussinessDocumentsTypeId);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar resoluciones de documentos comerciales.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.bussinessDocumentsResolutionId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una resolución de documentos comerciales.');
      return;
    }
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar la resolución de documentos comerciales?')) {
      try {
        await firstValueFrom(this.bussinessDocumentsResolutionService.deleteBussinessDocumentsResolution(this.bussinessDocumentsResolutionId));
        this.createNewRegister();
        this.toastHandlerService.showToast('success', 'La resolución de documentos comerciales fue eliminada exitosamente.');
      } catch (error) {
        console.error('Error al eliminar la resolución de documentos comerciales.', error);
      }
    }
  }

  async getButtonClick(buttonClick: any) {
    const bussinessDocumentsTypeId = this.formBussinessDocumentsResolution.get("bussinessDocumentsTypeId")?.value;
    if (!bussinessDocumentsTypeId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione un tipo de documento comercial.');
    }
    await this.handleBussinessDocumentsResolutionNavigation(buttonClick, bussinessDocumentsTypeId)
  }

  async getBussinessDocumentsType(bussinessDocumentsTypeId: number) {
    try {
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getBussinessDocumentsType(bussinessDocumentsTypeId));
      this.codeNameBranch = response.branch;
      this.codeNameEnterprise = response.enterprise;
      this.codeNameBussinessDocumentsType = response.bussinessDocumentsType;
      this.nameBussinessDocumentsTypeClass = response.bussinessDocumentsClass;
    } catch (error) {
      console.error('Error al obtener el tipo de documento comercial.', error);
    }
  }

  async getBussinessDocumentsResolutionById() {
    try {
      const resolutionId = this.bussinessDocumentsResolutionId;
      const response = await firstValueFrom(this.bussinessDocumentsResolutionService.getBussinessDocumentsResolutionById(resolutionId));
      this.bussinessDocumentsResolutionContract = response;
      await this.getBussinessDocumentsType(response.bussinessDocumentsTypeId);
      this.validateForm(this.bussinessDocumentsResolutionContract);
    } catch (error) {
      console.error('Error al obtener la resolución de documentos comerciales.', error);
    }
  }

  async getBussinessDocumentsTypesForSelection() {
    try {
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getBussinessDocumentsTypesForSelection(this.page,
        this.limit, this.columnSort, this.ascendant, this.filters));
      this.businessDocumentTypeSelectionData = response;
      this.updateInputsForBusinessDocumentTypeSelectionModal();
    } catch (error) {
      console.error('Error al obtener los tipos de documentos comerciales para el modal.', error);
    }
  }

  async getColumnsForSelection() {
    try {
      if (this.headersBusinessDocumentType.length === 0) {
        this.headersBusinessDocumentType = await firstValueFrom(this.bussinessDocumentsTypeService.getColumnsForSelection());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para los tipos de documentos comerciales.', error);
    }
  }

  async getPermission() {
    await this.getPermissionProfileByUrl();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.bussinessDocumentsResolutionId) {
      await this.getBussinessDocumentsResolutionById();
    } else {
      this.createNewRegister();
    }
  }

  async handleBussinessDocumentsResolutionNavigation(buttonClick: any, bussinessDocumentsTypeId: number) {
    const consecutive = this.formBussinessDocumentsResolution.get("consecutive")?.value;
    const actionMap: Record<string, () => Promise<BussinessDocumentsResolutionModel>> = {
      first: () =>
        firstValueFrom(this.bussinessDocumentsResolutionService.getFirstBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId)),
      previus: () =>
        firstValueFrom(this.bussinessDocumentsResolutionService.getPreviusBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId, consecutive)),
      next: () =>
        firstValueFrom(this.bussinessDocumentsResolutionService.getNextBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId, consecutive)),
      last: () =>
        firstValueFrom(this.bussinessDocumentsResolutionService.getLastBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetContract(bussinessDocumentsTypeId);
      return;
    }
    try {
      const bussinessDocumentsResolution = await action();
      this.bussinessDocumentsResolutionId = bussinessDocumentsResolution.bussinessDocumentsResolutionId;
      this.bussinessDocumentsResolutionContract = bussinessDocumentsResolution;
      this.validateForm(this.bussinessDocumentsResolutionContract);
      this.location.replaceState(`/${this.url}/register/${this.bussinessDocumentsResolutionId}`);
    } catch (error) {
      console.error(`Error al buscar la resolución de documentos comerciales (${buttonClick.target.id}).`, error);
    }
  }

  async openBusinessDocumentTypeSelectionModal() {
    try {
      this.filters = [];
      this.updateInputsForBusinessDocumentTypeSelectionModal();
      await this.getColumnsForSelection();
      await this.getBussinessDocumentsTypesForSelection();
      this.bussinessDocumentsTypesSelectionModalComponent?.show();
    } catch (error) {
      console.error('Error al abrir el modal de selección de ciudad.', error);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
    this.updateInputsForBusinessDocumentTypeSelectionModal();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getBussinessDocumentsTypesForSelection();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    this.validateFormControls();
    if (this.formBussinessDocumentsResolution.valid) {
      const modelBussinessDocumentsResolution = this.formBussinessDocumentsResolution.getRawValue() as BussinessDocumentsResolutionModel;
      if (modelBussinessDocumentsResolution.number == "") modelBussinessDocumentsResolution.number = null;
      if (modelBussinessDocumentsResolution.prefix == "") modelBussinessDocumentsResolution.prefix = null;
      if (modelBussinessDocumentsResolution.technologicPassword == "") modelBussinessDocumentsResolution.technologicPassword = null;
      if (this.bussinessDocumentsResolutionId == 0) {
        try {
          const response = await firstValueFrom(this.bussinessDocumentsResolutionService
            .createBussinessDocumentsResolution(modelBussinessDocumentsResolution));
          this.bussinessDocumentsResolutionId = response.bussinessDocumentsResolutionId;
          this.bussinessDocumentsResolutionContract = response;
          this.validateForm(this.bussinessDocumentsResolutionContract);
          this.location.replaceState(`/${this.url}/register/${this.bussinessDocumentsResolutionId}`);
          this.toastHandlerService.showToast('success', `La resolución de documentos comerciales fue creada exitosamente.`);
        } catch (error) {
          console.error('Error al crear la resolución de documentos comerciales.', error);
        }
      } else {
        this.bussinessDocumentsResolutionContract.number = modelBussinessDocumentsResolution.number;
        this.bussinessDocumentsResolutionContract.authorizeType = modelBussinessDocumentsResolution.authorizeType;
        this.bussinessDocumentsResolutionContract.dateResolution = modelBussinessDocumentsResolution.dateResolution;
        this.bussinessDocumentsResolutionContract.validity = modelBussinessDocumentsResolution.validity;
        this.bussinessDocumentsResolutionContract.prefix = modelBussinessDocumentsResolution.prefix;
        this.bussinessDocumentsResolutionContract.initialDocument = modelBussinessDocumentsResolution.initialDocument;
        this.bussinessDocumentsResolutionContract.finalDocument = modelBussinessDocumentsResolution.finalDocument;
        this.bussinessDocumentsResolutionContract.technologicPassword = modelBussinessDocumentsResolution.technologicPassword;
        this.bussinessDocumentsResolutionContract.idNumber = modelBussinessDocumentsResolution.idNumber;
        try {
          const response = await firstValueFrom(this.bussinessDocumentsResolutionService
            .updateBussinessDocumentsResolution(this.bussinessDocumentsResolutionContract));
          this.bussinessDocumentsResolutionContract = response;
          this.validateForm(this.bussinessDocumentsResolutionContract);
          this.toastHandlerService.showToast('success', `La resolución de documentos comerciales fue modificada exitosamente.`);
        } catch (error) {
          console.error('Error al modificar la resolución de documentos comerciales.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      bussinessDocumentsTypeId: {
        required: 'Debe seleccionar un Tipo de Documento.',
        min: 'Debe seleccionar un Tipo de Documento válido.'
      },
      number: {
        maxlength: 'El Número no puede tener más de 15 caracteres.'
      },
      dateResolution: {
        required: 'Debe ingresar la Fecha de Resolución.'
      },
      prefix: {
        maxlength: 'El Prefijo no puede tener más de 4 caracteres.'
      },
      initialDocument: {
        required: 'Debe ingresar el Número Inicial.',
        maxlength: 'El Número Inicial no puede tener más de 15 caracteres.'
      },
      finalDocument: {
        required: 'Debe ingresar el Número Final.',
        maxlength: 'El Número Final no puede tener más de 15 caracteres.'
      },
      technologicPassword: {
        maxlength: 'La Clave Tecnológica no puede tener más de 80 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formBussinessDocumentsResolution.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  resetContract(bussinessDocumentsTypeId: number) {
    this.codeNameBranch = '';
    this.codeNameEnterprise = '';
    this.codeNameBussinessDocumentsType = '';
    this.nameBussinessDocumentsTypeClass = '';
    this.bussinessDocumentsResolutionId = 0;
    this.bussinessDocumentsResolutionContract = new BussinessDocumentsResolutionModel();
    this.bussinessDocumentsResolutionContract.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
    this.validateForm(this.bussinessDocumentsResolutionContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  updateFormPermision() {
    if (this.permissionUpdatable) {
      this.disabledForm = false;
      const controlConsecutive = this.formBussinessDocumentsResolution.controls['consecutive'];
      setTimeout(() => {
        this.bussinessDocumentsResolutionContract.bussinessDocumentsResolutionId !== 0 ?
          controlConsecutive.enable() : controlConsecutive.disable();
      });
    } else {
      this.disabledForm = true;
      setTimeout(() => {
        this.formBussinessDocumentsResolution.disable();
        this.formControlStateService.setControlState(
          this.formBussinessDocumentsResolution,
          ['bussinessDocumentsTypeId', 'consecutive'],
          true
        );
      });
    }
  }

  updateInputsForBusinessDocumentTypeSelectionModal() {
    this.inputsForSelectDocumentTypesModal$.next({
      headers: this.headersBusinessDocumentType,
      data: this.businessDocumentTypeSelectionData,
      filters: this.filters,
      showCheckbox: true,
      showRecover: true
    });
  }

  async validateForm(bussinessDocumentsResolution: BussinessDocumentsResolutionModel) {
    this.formBussinessDocumentsResolution = this.formBuilder.group({
      bussinessDocumentsTypeId: [bussinessDocumentsResolution.bussinessDocumentsTypeId, [Validators.required, Validators.min(1)]],
      consecutive: [bussinessDocumentsResolution.consecutive],
      number: [bussinessDocumentsResolution.number, [Validators.maxLength(15)]],
      authorizeType: [bussinessDocumentsResolution.authorizeType],
      dateResolution: [bussinessDocumentsResolution.dateResolution ? this.dateConverterService
        .convertDatePreserveDay(bussinessDocumentsResolution.dateResolution) : null, [Validators.required]],
      validity: [bussinessDocumentsResolution.validity],
      prefix: [bussinessDocumentsResolution.prefix, [Validators.maxLength(4)]],
      initialDocument: [bussinessDocumentsResolution.initialDocument, [Validators.required, Validators.maxLength(15)]],
      finalDocument: [bussinessDocumentsResolution.finalDocument, [Validators.required, Validators.maxLength(15)]],
      technologicPassword: [bussinessDocumentsResolution.technologicPassword, [Validators.maxLength(80)]],
      idNumber: [bussinessDocumentsResolution.idNumber]
    });
    this.updateFormPermision();
  }

  validateFormControls() {
    Object.keys(this.formBussinessDocumentsResolution.controls).forEach((key) => {
      const control = this.formBussinessDocumentsResolution.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
